import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { IRoute } from 'data';
import { commonHooks } from 'hooks';

const { Sider } = Layout;
const { SubMenu } = Menu;
const { useAppMenu } = commonHooks;

interface AppSiderProps {
  filteredNavigation: IRoute[];
}

const AppSider: React.FC<AppSiderProps> = props => {
  const params = useParams<any>();

  // Get selectedKey, openKey from route & pathname
  const { filteredNavigation } = props;
  const { selectedKey, openKey } = useAppMenu(filteredNavigation);

  return (
    <Sider className={`app-sider`} trigger={null} width={200}>
      <Menu
        className="app-menu"
        theme="dark"
        mode="inline"
        defaultOpenKeys={[openKey]}
        selectedKeys={[selectedKey]}
      >
        {filteredNavigation.map(item => {
          if (!item.icon) return null;
          if (!item.children) {
            return (
              <Menu.Item key={item.path}>
                <Link to={replaceParams(item.path, params)}>
                  <item.icon className="app-icon" />
                  <span>{item.name}</span>
                </Link>
              </Menu.Item>
            );
          } else {
            const { children } = item;
            const childs = filteredNavigation.filter(
              child => children.includes(child.path) && !child.children
            );
            return (
              <SubMenu
                key={item.path}
                title={
                  <span>
                    <item.icon className="app-icon" />
                    <span>{item.name}</span>
                  </span>
                }
              >
                {childs.map(child => {
                  return (
                    <Menu.Item key={child.path}>
                      <Link to={replaceParams(child.path, params)}>
                        {child.name}
                      </Link>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
            );
          }
        })}
      </Menu>
    </Sider>
  );
};

export default AppSider;

function replaceParams(path: string, params: any): string {
  return Object.keys(params).reduce(
    (path, key) => path.replace(`:${key}`, params[key] as string),
    path
  );
}
